<template>
	<div class="base-content">
		<van-cell-group>
			<van-cell is-link title="日期" :value="currentDateShow" @click="openDateTime()" />
		</van-cell-group>

		<van-popup v-model="showTime" position="bottom" :style="{ height: '50%' }">
			<van-datetime-picker v-model="currentDate" type="date" :min-date="minDate" :max-date="maxDate" @confirm="confirm()"
			 @cancel="cancel()" />
		</van-popup>

		<div class="drop-box">
			<p class="drop-lable">班次</p>
			<van-dropdown-menu class="drop-item-1" :change="onDropdownChange()">
				<van-dropdown-item v-model="abnormalStatus" :options="abnormalStatusList" />
			</van-dropdown-menu>
		</div>

		<div class="space"></div>

		<van-row class="padding-bottom">
			<van-col span="6">
				<div class="number-red-blod text-center">{{totalData.studentNum}}</div>
				<div class="text-title-3 text-center">总人数</div>
			</van-col>
			<van-col span="6">
				<div class="number-yellow-blod text-center">{{totalData.noLiveInDormitory}}</div>
				<div class="text-title-3 text-center">走读生</div>
			</van-col>
			<van-col span="6">
				<div class="number-green-blod text-center">{{totalData.liveInDormitory}}</div>
				<div class="text-title-3 text-center">住宿生</div>
			</van-col>
			<van-col span="6">
				<div class="number-black-blod text-center">{{totalData.passInNum}}</div>
				<div class="text-title-3 text-center">进校人次</div>
			</van-col>
		</van-row>
		<van-row class="padding-bottom">
			<van-col span="6">
				<div class="number-red-blod text-center">{{totalData.passOutNum}}</div>
				<div class="text-title-3 text-center">出校人次</div>
			</van-col>
			<van-col span="6">
				<div class="number-yellow-blod text-center">{{totalData.tempUnresonableUserNum}}</div>
				<div class="text-title-3 text-center">体温异常</div>
			</van-col>
			<van-col span="6">
				<div class="number-green-blod text-center">{{totalData.tempResonableUserNum}}</div>
				<div class="text-title-3 text-center">体温正常</div>
			</van-col>
			<van-col span="6">
				<div class="number-black-blod text-center">{{totalData.noReportTempUserNum}}</div>
				<div class="text-title-3 text-center">未上报</div>
			</van-col>
		</van-row>

		<van-row class="sub-title">
			<van-col span="7"></van-col>
			<van-col span="4" class="text-title-2 number-black text-center">总人数</van-col>
			<van-col span="4" class="text-title-2 number-green text-center">体温正常</van-col>
			<van-col span="4" class="text-title-2 number-red text-center">体温异常</van-col>
			<van-col span="4" class="text-title-2 number-black text-center">未上报</van-col>
			<van-col span="1"></van-col>
		</van-row>

		<div class="content-box">
			<van-row class="sub-content" @click="goDetail(item.clazzDeptId)" v-for="item of backData" :key="item.id">
				<van-col span="7" class="text-title-2">{{item.clazzName}}</van-col>
				<van-col span="4" class="text-title-2 number-black text-center">{{item.studentNum}}</van-col>
				<van-col span="4" class="text-title-2 number-green text-center">{{item.tempResonableUserNum}}</van-col>
				<van-col span="4" class="text-title-2 number-red text-center">{{item.tempUnresonableUserNum}}</van-col>
				<van-col span="4" class="text-title-2 number-black text-center">{{item.noReportTempUserNum}}</van-col>
				<van-col span="1" class="text-title-2 number-black text-center">
					<van-icon name="arrow" class="icon" />
				</van-col>
			</van-row>
		</div>

		<van-overlay :show="showLoading">
			<van-loading size="30px" color="#FFFFFF" vertical class="margin-8">加载中...</van-loading>
		</van-overlay>

		<bottom-tab></bottom-tab>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Col,
		Row
	} from "vant";
	import {
		Icon
	} from "vant";
	import {
		Cell,
		CellGroup
	} from "vant";
	import {
		DatetimePicker
	} from "vant";
	import {
		Popup
	} from "vant";
	import {
		Toast
	} from "vant";
	import {
		api
	} from "../../http/api";
	import axios from "axios";
	import commonObj from '../../common/common.js'
	Vue.use(Col);
	Vue.use(Row);
	Vue.use(Icon);
	Vue.use(Cell);
	Vue.use(CellGroup);
	Vue.use(DatetimePicker);
	Vue.use(Popup);

	export default {
		data() {
			return {
				showLoading: false,
				showTime: false,
				minDate: new Date(2019, 0, 1),
				maxDate: new Date(2030, 11, 31),
				currentDate: this.getSession("schStuDailycurrentDateShow") ?
					new Date(this.getSession("schStuDailycurrentDateShow")) : new Date(),
				currentDateShow: this.getSession("schStuDailycurrentDateShow") ||
					this.formatDate(new Date(), "yyyy/MM/dd"),
				abnormalStatus: 0,
				abnormalStatusList: [],
				startTime: "",
				endTime: "",
				timeObj: {},
				backData: [],
				totalData: {
					studentNum: 0,
					liveInDormitory: 0,
					noLiveInDormitory: 0,
					passInNum: 0,
					passOutNum: 0,
					tempResonableUserNum: 0,
					tempUnresonableUserNum: 0,
					noReportTempUserNum: 0
				}
			};
		},
		created: function() {
			//如果已经获取到班次, 则直接取数据
			let startTime = this.getSession("schStuDailyStartTime");
			let endTime = this.getSession("schStuDailyEndTime");
			if (startTime) {
				this.startTime = startTime;
				this.endTime = endTime;
				this.abnormalStatus = this.getSession("schStuDailyAbnormalStatus");
				this.abnormalStatusList = JSON.parse(
					this.getSession("schStuDailyAbnormalStatusList")
				);
				this.loadData();
				return;
			}
			this.loadShifts();
		},

		//列表页处理数据缓存， 直接照搬使用， 变量使用需要返回到前一页的路由
		beforeRouteLeave(to, from, next) {
			if (to.path == "/" || to.path == "/manorStuDaily") {
				this.clearSession("schStuDailyEndTime");
				this.clearSession("schStuDailyAbnormalStatus");
				this.clearSession("schStuDailyList");
				this.clearSession("schStuDailyAbnormalStatusList");
				this.clearSession("schStuDailycurrentDateShow");
				this.clearSession("schStuDailycurrentDate");
				this.clearSession("schStuDailyStartTime");
				this.clearSession("schStuDailyTotal");
			}
			next();
		},

		methods: {
			clearSession(key) {
				window.sessionStorage.removeItem(key);
			},
			putSesstion(key, value) {
				window.sessionStorage.setItem(key, value);
			},
			getSession(key) {
				return window.sessionStorage.getItem(key);
			},
			//获取班次
			loadShifts() {
				let aa = -1; //临时变量, 无任何意义.
				let schoolId = this.$route.query.id;
				if (!schoolId) {
					schoolId = this.getLocalStorage("scId");
				}
				let key = "school_" + schoolId + "_TempInfo";
				axios({
					url: commonObj.BASEURL + "/config/find/" + key + "/CommonConfig",
					method: "get"
				}).then(res => {
					//解析班次
					let temp = JSON.parse(res.data.data.configValue).scheduleList;
					//填充班次数据
					for (let i = 0; i < temp.length; i++) {
						temp[i]["text"] =
							temp[i].name + ": " + temp[i].startTime + " - " + temp[i].endTime;
						temp[i]["value"] = temp[i].id;
					}

					//处理班次匹配回填
					let flag = 0;
					while (aa == -1  && flag < temp.length) {
						aa = this.checkAuditTime(
							temp[flag].startTime,
							temp[flag].endTime,
							temp[flag].id
						);
						this.timeObj = temp[flag];
						flag++;
					}
					// this.abnormalStatus = aa;
					if( aa != -1 && temp && temp.length > 0){
						this.abnormalStatus = aa;
						console.log(this.abnormalStatus)
					}else if(aa == -1 && temp && temp.length > 0){
						this.abnormalStatus = temp[0].id
					}else{
						this.abnormalStatus = aa
					}
					this.abnormalStatusList = temp;

					//缓存班次数据
					this.putSesstion(
						"schStuDailyAbnormalStatusList",
						JSON.stringify(this.abnormalStatusList)
					);
					this.putSesstion("schStuDailyAbnormalStatus", this.abnormalStatus);

					this.startTime = this.currentDateShow + " " + this.timeObj.startTime;
					this.endTime = this.currentDateShow + " " + this.timeObj.endTime;

					//缓存班次时间
					this.putSesstion("schStuDailyStartTime", this.startTime);
					this.putSesstion("schStuDailyEndTime", this.endTime);

					this.loadData();
				});
			},
			loadData() {
				//页面进入时先获取缓存存储的数据
				let schStuDailyList = this.getSession("schStuDailyList");
				let schStuDailyTotal = this.getSession("schStuDailyTotal");
				if (schStuDailyList) {
					this.backData = JSON.parse(schStuDailyList);
					this.totalData = JSON.parse(schStuDailyTotal);
					return;
				}

				this.showLoading = true;

				let schoolId = this.$route.query.id;
				if (!schoolId) {
					schoolId = this.getLocalStorage("scId");
				}
				let data =
					`start=${this.startTime}&end=${this.endTime}&schoolId=${schoolId}&size=500&index=1`;
				axios({
					url: commonObj.BASEURL +
						"/temp/school/clazz/student/dateRange/report?" + encodeURI(data),
					method: "get"
				}).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.showLoading = false;
						this.backData = res.data.data.data;

						//每次刷新数据之前先清空数据
						this.totalData = {
							studentNum: 0,
							liveInDormitory: 0,
							noLiveInDormitory: 0,
							passInNum: 0,
							passOutNum: 0,
							tempResonableUserNum: 0,
							tempUnresonableUserNum: 0,
							noReportTempUserNum: 0
						};
						for (let i = 0; i < this.backData.length; i++) {
							this.totalData.studentNum += this.backData[i].studentNum;
							this.totalData.liveInDormitory += this.backData[i].liveInDormitory;
							this.totalData.noLiveInDormitory += this.backData[
								i
							].noLiveInDormitory;
							this.totalData.passInNum += this.backData[i].passInNum;
							this.totalData.passOutNum += this.backData[i].passOutNum;
							this.totalData.tempResonableUserNum += this.backData[
								i
							].tempResonableUserNum;
							this.totalData.tempUnresonableUserNum += this.backData[
								i
							].tempUnresonableUserNum;
							this.totalData.noReportTempUserNum += this.backData[
								i
							].noReportTempUserNum;
						}

						//数据加载完成之后将数据缓存
						this.putSesstion("schStuDailyTotal", JSON.stringify(this.totalData));
						this.putSesstion("schStuDailyList", JSON.stringify(this.backData));
					} else if (res.data.code == 10002) {
						this.showLoading = false;
						Toast(res.data.msg);
					}
				});
			},
			//当班次改变时
			onDropdownChange() {
				let abnormalStatus = this.getSession("schStuDailyAbnormalStatus");
				if (this.abnormalStatus == -1) return;
				if (abnormalStatus && abnormalStatus != this.abnormalStatus) {
					this.putSesstion("schStuDailyAbnormalStatus", this.abnormalStatus);
					//这里切换了班次, 调用刷新方法

					for (let i = 0; i < this.abnormalStatusList.length; i++) {
						if (this.abnormalStatusList[i].id == this.abnormalStatus) {
							this.timeObj = this.abnormalStatusList[i];
							this.startTime =
								this.currentDateShow + " " + this.timeObj.startTime;
							this.endTime = this.currentDateShow + " " + this.timeObj.endTime;

							//缓存班次时间
							this.putSesstion("schStuDailyStartTime", this.startTime);
							this.putSesstion("schStuDailyEndTime", this.endTime);

							this.clearSession("schStuDailyTotal");
							this.clearSession("schStuDailyList");
							this.loadData();
						}
					}
				}
			},

			checkAuditTime(beginTime, endTime, value) {
				var nowDate = new Date();
				var beginDate = new Date(nowDate);
				var endDate = new Date(nowDate);

				var beginIndex = beginTime.lastIndexOf(":");
				var beginHour = beginTime.substring(0, beginIndex);
				var beginMinue = beginTime.substring(beginIndex + 1, beginTime.length);
				beginDate.setHours(beginHour, beginMinue, 0, 0);

				var endIndex = endTime.lastIndexOf(":");
				var endHour = endTime.substring(0, endIndex);
				var endMinue = endTime.substring(endIndex + 1, endTime.length);
				endDate.setHours(endHour, endMinue, 0, 0);
				if (
					nowDate.getTime() - beginDate.getTime() >= 0 &&
					nowDate.getTime() <= endDate.getTime()
				) {
					return value;
				} else {
					return -1;
				}
			},
			getLocalStorage(key) {
				return window.localStorage.getItem(key);
			},
			openDateTime() {
				this.showTime = true;
			},
			cancel() {
				this.showTime = false;
			},
			confirm() {
				this.showTime = false;
				this.currentDate = new Date(this.currentDate);
				this.currentDateShow = this.formatDate(this.currentDate, "yyyy/MM/dd");

				this.putSesstion("schStuDailycurrentDate", this.currentDate);
				this.putSesstion("schStuDailycurrentDateShow", this.currentDateShow);

				this.clearSession("schStuDailyList");
				this.clearSession("schStuDailyTotal");

				this.startTime = this.currentDateShow + " " + this.timeObj.startTime;
				this.endTime = this.currentDateShow + " " + this.timeObj.endTime;

				this.loadData();
			},
			formatDate(date, fmt) {
				date = date == undefined ? new Date() : date;
				date = typeof date == "number" ? new Date(date) : date;
				fmt = fmt || "yyyy-MM-dd HH:mm:ss";
				let obj = {
					y: date.getFullYear(), // 年份，注意必须用getFullYear
					M: date.getMonth() + 1, // 月份，注意是从0-11
					d: date.getDate(), // 日期
					q: Math.floor((date.getMonth() + 3) / 3), // 季度
					w: date.getDay(), // 星期，注意是0-6
					H: date.getHours(), // 24小时制
					h: date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, // 12小时制
					m: date.getMinutes(), // 分钟
					s: date.getSeconds(), // 秒
					S: date.getMilliseconds() // 毫秒
				};
				let week = ["天", "一", "二", "三", "四", "五", "六"];
				for (let i in obj) {
					fmt = fmt.replace(new RegExp(i + "+", "g"), function(m) {
						let val = obj[i] + "";
						if (i == "w") return (m.length > 2 ? "星期" : "周") + week[val];
						for (let j = 0, len = val.length; j < m.length - len; j++)
							val = "0" + val;
						return m.length == 1 ? val : val.substring(val.length - m.length);
					});
				}
				return fmt;
			},
			goDetail: function(id) {
				this.$router.push({
					path: "classDaily",
					query: {
						id: id
					}
				});
			}
		}
	};
</script>

<style>
	.base-content {
		padding: 10px 10px 0px 10px;
	}

	.van-hairline--top-bottom::after,
	.van-hairline-unset--top-bottom::after {
		border-width: 0;
	}

	.content-box {
		width: 100%;
		/* height: 329px; */
		overflow: scroll;
	}

	.icon {
		font-size: 0.25rem;
		margin-top: 2px;
	}

	.sub-title {
		width: 100%;
		height: 35px;
		background-color: rgb(241, 241, 241);
	}

	.sub-content {
		width: 100%;
		min-height: 40px;
		border-bottom: 1px solid rgb(241, 241, 241);
	}

	.text-center {
		text-align: center;
	}

	.number-red-blod {
		font-weight: bold;
		color: rgb(255, 0, 0);
		font-size: 0.4rem;
	}

	.number-yellow-blod {
		font-weight: bold;
		color: rgb(255, 204, 0);
		font-size: 0.4rem;
	}

	.number-green-blod {
		font-weight: bold;
		color: rgb(103, 194, 58);
		font-size: 0.4rem;
	}

	.number-black-blod {
		font-weight: bold;
		color: #2c3e50;
		font-size: 0.4rem;
	}

	.number-red {
		color: rgb(255, 0, 0);
		font-size: 0.4rem;
	}

	.number-yellow {
		color: rgb(255, 204, 0);
		font-size: 0.4rem;
	}

	.number-green {
		color: rgb(103, 194, 58);
		font-size: 0.4rem;
	}

	.number-black {
		color: #2c3e50;
		font-size: 0.4rem;
	}

	.text-title-3 {
		font-size: 0.3rem;
	}

	.text-title-2 {
		font-size: 0.24rem;
		white-space: normal;
		padding: 10px 0;
	}

	.padding-bottom {
		padding-bottom: 5px;
		padding-top: 5px;
	}
</style>
